export const PatientSidebarItemKeys = {
  Chat: 'chat',
  Notes: 'notes',
  LiveCalls: 'liveCalls',
  Copilot: 'copilot',
  Greyfinch: 'greyfinch',
  OpenClarity: 'open-clarity'
}
